import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import axios from 'axios'
import { nextTick } from 'process'
import { onMounted, ref, watch } from 'vue'

import { getMarkDownData } from './index'

interface ImpFuncInfo {
  id: number
  key: string
  update_id: number
  is_red: boolean
  ad_content_url: string
  create_time: string
  title: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-importFuncModal',
  setup(__props) {

const content = ref(null)
// 弹窗是否展示
const visible = ref()
// 当前tab的内容
const curentContent = ref('')
// 当前ab标题
const curContentTitile = ref('')

// 是否预览图片
const isShowImage = ref(false)
const imageRef = ref()
const tabList = ref<ImpFuncInfo[]>([])
// 当前展示的图片地址
const currentImageSrc = ref('')
function handlerCancel() {
  store.commit('setImportFunc', false)
  isShowImage.value = false
}
/**
 * @desc 处理菜单选择事件 加载对应内容
 * @param
 */
function handleSelect(data: ImpFuncInfo) {
  axios.get(data.ad_content_url).then((res) => {
    curentContent.value = res.data.html
    curContentTitile.value = res.data.ad_title
  })
}
function handlerFullScreen() {
  if (content.value) {
    // content.value.requestFullscreen()
  }
}
/**
 * @desc 通过url获取内容
 * @param url 链接
 */
async function getMarkDownDataByUrl() {
  try {
    const res = await getMarkDownData()

    // 获取上线的
    tabList.value = res.data.data.map((item: ImpFuncInfo, index: number) => {
      item.key = index.toString()
      return item
    })

    changeImageList()
    // 默认选择第一个
    handleSelect(tabList.value[0])
  } catch (error) {}
}
/**
 * @desc 给图片加上预览功能
 */
function changeImageList() {
  nextTick(() => {
    const images = document.querySelectorAll('.image-text')
    images.forEach((ele) => {
      ele.addEventListener('click', (e: any) => {
        if (e.target.tagName === 'VIDEO') {
          e.target.style.width = 100 + '%'
          e.target.style.height = 100 + '%'
        }

        // 只有图片有预览效果
        e.target instanceof HTMLImageElement && preOrCancleImg(e.target.src)
      })
    })
    document.querySelector('.preImg')?.addEventListener('click', (e) => {
      e.target instanceof HTMLImageElement && preOrCancleImg('')
    })
  })
}
/**
 * @desc 预览或者取消预览
 * @param src
 */
function preOrCancleImg(src: string) {
  currentImageSrc.value = src
  isShowImage.value = true
}
watch(
  () => store.state.showImportFunc,
  (val) => {
    if (val) {
      getMarkDownDataByUrl()
    }
    visible.value = val
  }
)
onMounted(() => {
  const showSpecificFunc = sessionStorage.getItem('showSpecificFunc')
  if (showSpecificFunc === 'true') {
    visible.value = true
    getMarkDownDataByUrl()
  }
})

return { __sfc: true,content, visible, curentContent, curContentTitile, isShowImage, imageRef, tabList, currentImageSrc, handlerCancel, handleSelect, handlerFullScreen, getMarkDownDataByUrl, changeImageList, preOrCancleImg }
}

})